import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function QCPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20 md:pt-24">
        <section className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16 bg-primary-50">
          <div className="max-w-3xl mx-auto">
            <nav className="text-sm text-foreground-500 mb-6">
              <a href="/" className="hover:text-primary-600 transition-colors">Home</a>
              <span className="mx-2">/</span>
              <span className="text-foreground-700">QC Guide</span>
            </nav>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">CSSBuy QC Guide</h1>
            <p className="text-foreground-600 text-lg">Learn how to read QC photos, check measurements, and verify product details before shipping.</p>
          </div>
        </section>
        <section className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
          <div className="max-w-3xl mx-auto space-y-8">
            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-3">What Is QC?</h2>
              <p className="text-foreground-700 mb-2">QC stands for Quality Control. It is the process of inspecting your purchased items at the warehouse before they are shipped to you. CSSBuy takes photos of your items so you can verify condition, accuracy, and quality.</p>
            </div>
            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-3">How to Read QC Photos</h2>
              <p className="text-foreground-700 mb-2">When viewing QC photos, check for: correct product version, proper stitching and materials, accurate colors, correct sizing, and any visible defects. Compare with the original product listing when possible.</p>
            </div>
            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-3">Measurements</h2>
              <p className="text-foreground-700 mb-2">For clothing and shoes, QC photos often include measurements. Compare these with size charts and your own measurements. Remember that manual measurements may have small variations.</p>
            </div>
            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-3">When to Reject QC</h2>
              <p className="text-foreground-700 mb-2">If the item is clearly wrong, damaged, or significantly different from what was ordered, you can request an exchange or return through CSSBuy before the item is shipped to you.</p>
            </div>
            <div className="bg-primary-50 rounded-xl p-6 border border-primary-200/50">
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-2">Pro Tip</h2>
              <p className="text-foreground-700 text-sm">Always request detailed QC photos if they are not provided automatically. Specific angles, close-ups, and measurement photos can save you from receiving unwanted items.</p>
            </div>
            <div className="text-center">
              <a href="/" className="inline-flex items-center px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md transition-colors">
                <i className="ri-arrow-left-line mr-2"></i>
                Back to Homepage
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}